var options = {
    scroll: false,
    update: false
};
export default options;
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
export function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            scroll: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/pagescroll/_options.js
// module id = 22
// module chunks = 0